{
  "SEARCH": {
    "TABS": {
      "ALL": "Hepsi",
      "CONTACTS": "Kişiler",
      "CONVERSATIONS": "Konuşmalar",
      "MESSAGES": "Mesajlar"
    },
    "SECTION": {
      "CONTACTS": "Kişiler",
      "CONVERSATIONS": "Konuşmalar",
      "MESSAGES": "Mesajlar"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Aranıyor",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "{query} sorgusunda hiç bir {item} bulunamadı",
    "EMPTY_STATE_FULL": "{query} sorgusu için hiç bir sonuç bulunamadı",
    "PLACEHOLDER_KEYBINDING": "odaklanmak için / basın",
    "INPUT_PLACEHOLDER": "Aramak için 3 veya daha fazla karakter yazın",
    "RECENT_MESSAGES": "Son gönderdiğim mesajlar",
    "EMPTY_STATE_DEFAULT": "Daha iyi arama sonuçları için konuşma id si, e-posta, telefon numarası, mesajlara göre arama yapın. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Daha fazla bilgi edinin",
    "WROTE": "wrote:",
    "FROM": "dan",
    "EMAIL": "e-Posta",
    "EMAIL_SUBJECT": "konu"
  }
}
